var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 23",
    style: {
      enableBackground: "new 0 0 26 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#424B5A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4321",
    className: "st0",
    d: "M13,953.6c-6.1,0-11,4.7-11,10.4c0,5.8,4.9,10.4,11,10.4s11-4.7,11-10.4 C24,958.3,19,953.6,13,953.6z M13,955c5.3,0,9.5,4,9.5,9.1c0,5-4.3,9.1-9.5,9.1s-9.5-4-9.5-9.1C3.4,959.1,7.7,955,13,955z  M13,956.7c-0.3,0-0.7,0.3-0.7,0.7v0.8c-1.9,0.3-3.2,1.6-3.2,3.2c0,1.1,0.5,1.9,1.2,2.4c0.7,0.5,1.6,0.8,2.5,1 c0.8,0.2,1.5,0.5,2,0.8c0.4,0.3,0.7,0.6,0.7,1.3c0,0.9-0.8,1.9-2.4,1.9c-0.6,0-1.3-0.2-1.8-0.6c-0.5-0.3-0.7-0.7-0.7-1.1 c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7c0,0.9,0.5,1.7,1.3,2.2c0.5,0.4,1.2,0.7,1.9,0.8v0.8c0,0.4,0.4,0.7,0.7,0.7 c0.3,0,0.7-0.3,0.7-0.7v-0.8c1.9-0.3,3.2-1.6,3.2-3.2c0-1.1-0.5-1.9-1.2-2.4c-0.7-0.5-1.6-0.8-2.5-1c-0.8-0.2-1.5-0.5-2-0.8 c-0.4-0.3-0.7-0.6-0.7-1.3c0-0.9,0.8-1.9,2.4-1.9c0.6,0,1.3,0.2,1.8,0.6s0.7,0.7,0.7,1.1c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7c0-0.9-0.5-1.7-1.3-2.2c-0.5-0.4-1.2-0.7-1.9-0.8v-0.8C13.7,957,13.3,956.7,13,956.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.f8e35b9bb2734fcc6a3e1d373855d230.svg";
export { ForwardRef as ReactComponent };